<script>
export default {
  name: "MediaFilters",
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      typeOptions: [
        { value: "image", text: "Imagen" },
        { value: "pdf", text: "PDF" },
        { value: "word", text: "Word" },
        { value: "excel", text: "Excel" },
        { value: "powerpoint", text: "PowerPoint" },
        { value: "text", text: "Texto" },
        { value: "zip", text: "Comprimido" },
        { value: "other", text: "Otro" },
      ],
    };
  },
  methods: {
    apply() {
      this.$emit("apply");
    },
    reset() {
      this.$emit("reset");
    },
  },
};
</script>

<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3 mb-2">
          <label class="small mb-1">Nombre</label>
          <input
            v-model="filters.name"
            type="text"
            class="form-control form-control-sm"
            placeholder="Buscar por nombre..."
            @keyup.enter="apply"
          />
        </div>
        <div class="col-md-2 mb-2">
          <label class="small mb-1">Tipo</label>
          <b-form-select
            v-model="filters.type"
            :options="[{ value: null, text: 'Todos' }, ...typeOptions]"
            size="sm"
          />
        </div>
        <div class="col-md-2 mb-2">
          <label class="small mb-1">Extensión</label>
          <input
            v-model="filters.extension"
            type="text"
            class="form-control form-control-sm"
            placeholder="ej. pdf, png"
          />
        </div>
        <div class="col-md-2 mb-2">
          <label class="small mb-1">Desde</label>
          <input v-model="filters.start_date" type="date" class="form-control form-control-sm" />
        </div>
        <div class="col-md-2 mb-2">
          <label class="small mb-1">Hasta</label>
          <input v-model="filters.end_date" type="date" class="form-control form-control-sm" />
        </div>
        <div class="col-md-1 mb-2 d-flex align-items-end">
          <b-form-checkbox v-model="filters.only_images" class="mb-2">
            Solo imágenes
          </b-form-checkbox>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-light mr-2" @click="reset">
          Limpiar
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="apply">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>
